import { cva } from 'class-variance-authority';
import { tw } from '@/common';

export const mepTypeVariants = cva([tw`font-satoshi`], {
  variants: {
    scheme: {
      onSurface: tw`text-surface-on`,
      onSurfaceVariant: tw`text-surface-variant-on`,
      onSurfaceInverse: tw`text-surface-inverse-on`,
      onPrimary: tw`text-primary-on`,
      onSecondaryContainer: tw`text-secondary-container-on`,
      error: tw`text-error`,
      custom: undefined,
    },
    variant: {
      'display-medium': tw`text-[45px] font-black leading-[52px]`,
      'display-small': tw`text-3xl font-black leading-[44px]`,

      'headline-small': tw`text-2xl font-bold leading-8 tracking-normal`,
      'headline-medium': tw`text-[28px] font-bold leading-9 tracking-normal`,

      'feature-large': tw`text-xl font-medium leading-[26px]`,
      'feature-large-prominent': tw`text-xl font-bold leading-[26px]`,

      'title-medium': tw`text-base font-medium leading-6 tracking-[0.15px]`,
      'title-small': tw`text-sm font-medium leading-5 tracking-[0.1px]`,

      'label-large': tw`text-sm font-medium leading-5 tracking-[0.1px]`,
      'label-large-prominent': tw`text-sm font-bold leading-5 tracking-[0.1px]`,
      'label-medium': tw`text-xs font-medium leading-4 tracking-[0.5px]`,

      'body-large': tw`text-base font-normal leading-6 tracking-[0.5px]`,
      'body-medium': tw`text-sm font-normal leading-5 tracking-[0.25px]`,
      'body-small': tw`text-xs font-normal leading-4 tracking-[0.4px]`,
    },
    bold: {
      true: tw`!font-bold`,
      false: undefined,
    },
  },
});
